/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import './style.sass';

import ListItem from './ListItem';

const MainList = (props) => {
  const {
    featuredLocations,
    popularLocations,
  } = props;

  return (
    <div className="container">
      <div className="locations-list bordered-section">
        <div className="row">
          <div className="col-md-6">
            <h2 className="black bold">{I18n.t('home.new_serviced_offices')}</h2>

            {popularLocations.map(location => (
              <ListItem
                key={location.id}
                title={location.address_title}
                body={location.desc}
                image={location.primary_photo_url}
                href={location.url}
                starsRating={location.stars_rating}
              />
            ))}

          </div>
          <div className="col-md-6">
            <h2 className="black bold secong-list">{I18n.t('frontpage.blocks.featured.title')}</h2>

            {featuredLocations.map(location => (
              <ListItem
                key={location.id}
                title={location.address_title}
                body={location.desc}
                image={location.primary_photo_url}
                href={location.url}
                stars_rating={location.stars_rating}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

MainList.propTypes = {
  featuredLocations: PropTypes.oneOfType([PropTypes.array]),
  popularLocations: PropTypes.oneOfType([PropTypes.array]),
};

MainList.defaultProps = {
  featuredLocations: [],
  popularLocations: [],
};

export default MainList;
